import React, { useId } from 'react';
import './FlippexLoader.css';

/**
 * The Flippex mark, loading.
 *
 * Two circles on the brand's own geometry (fitted to the logo: r 27, centres 39.64 / 60.36 on a 100
 * viewBox) travel along the diagonal, meet to form the mark, hold, and separate again. Each circle is
 * masked by the other, so the overlap is the real background showing through - never a white fill.
 */
const PINK = 'rgb(var(--primary))';

export const FlippexLoader = ({ size = 48, label = 'Loading', className = '', animate = true }) => {
  const id = useId().replace(/:/g, '');
  const maskA = `flippex-mask-a-${id}`;
  const maskB = `flippex-mask-b-${id}`;

  return (
    <div
      role="status"
      aria-label={label}
      className={`flippex-loader ${animate ? '' : 'flippex-loader--static'} ${className}`}
      style={{ width: size, height: size }}
      data-testid="flippex-loader"
    >
      <svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true">
        <defs>
          {/* Each mask hides the other circle, leaving the intersection transparent. */}
          <mask id={maskA} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
            <rect width="100" height="100" fill="white" />
            <g className="flippex-circle-b">
              <circle cx="60.36" cy="60.36" r="27" fill="black" />
            </g>
          </mask>
          <mask id={maskB} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
            <rect width="100" height="100" fill="white" />
            <g className="flippex-circle-a">
              <circle cx="39.64" cy="39.64" r="27" fill="black" />
            </g>
          </mask>
        </defs>

        <g className="flippex-circle-a">
          <circle cx="39.64" cy="39.64" r="27" style={{ fill: PINK }} mask={`url(#${maskA})`} />
        </g>
        <g className="flippex-circle-b">
          <circle cx="60.36" cy="60.36" r="27" style={{ fill: PINK }} mask={`url(#${maskB})`} />
        </g>
      </svg>
    </div>
  );
};

export default FlippexLoader;
